import React, { useState } from 'react'
import styled from 'styled-components'
import { up } from 'styled-breakpoints'

import Tabs from '../../tabs'

import FavoriteBook from './favorite'
import TrendingBooks from './trending'
import GoodreadsOnboarding from './goodreads'
import { DialogLevel, useDialog } from '../../dialog/hook'
import ReadingLanguagesDialog from './reading-languages'

type OnboardingDialogProps = {
}


const OnboardingDialog: React.FunctionComponent<OnboardingDialogProps> = ({  }) => {
    const { closeDialog } = useDialog()

    const [tab, setTab] = useState("favorite")
    
    const finishOnboarding = () => window.location.reload()

    const captions = [
        { "title": "Favorite book", "value": "favorite" },
        { "title": "Trending books", "value": "trending" },
        { "title": "Goodreads import", "value": "goodreads" }
    ]

    return (
        <Container>
            <CloseContainer onClick={() => closeDialog()}>
                <Close src={require('./images/close.svg')}/>
            </CloseContainer>
            <Tabs captions={captions} onChange={(tab) => setTab(tab)} value={tab} />
            {
                tab === "favorite" && <FavoriteBook onOnboardingFinished={finishOnboarding}/>
            }
            {
                tab === "trending" && <TrendingBooks onOnboardingFinished={finishOnboarding}/>
            }
            {
                tab === "goodreads" && <GoodreadsOnboarding onOnboardingFinished={finishOnboarding}/>
            }
        </Container>
    )
}

export const useOnboarding = (level: DialogLevel) => {
    const { setComponent } = useDialog()

    return () => {
        setComponent(
            <ReadingLanguagesDialog 
                onUpdated={() => setComponent(<OnboardingDialog />, undefined, undefined, true)}
            />, 
            undefined, 
            level,
            true
        )
    }
}

const Container = styled.div`
    position: relative;

    display: grid;
    align-items: start;
    
    grid-template-columns: 1fr;
    grid-row-gap: 24px;
    grid-column-gap: 24px;

    width: 100%;
    height: 100%;

    padding: 0 24px 24px 24px;

    background: ${p => p.theme.colors.bg};
    border-radius: 10px;

    ${up('desktop')} {
        width: 1024px;
        height: fit-content;
        grid-column-gap: 48px;
    }

    overflow-y: hidden;
`

const CloseContainer = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    
    height: 60px;
    width: 60px;

    display: grid;
    align-items: center;
    justify-items: center;

    cursor: pointer;
    z-index: 10;
`

const Close = styled.img`
    width: 20px;
    height: 20px;
`


export default OnboardingDialog